var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"max-width":"370px"}},[_c('v-img',{staticClass:"icon mt-n7",attrs:{"src":require('@/assets/icons/'+_vm.img+'.png'),"contain":"","height":"60","width":"100%"}}),_c('div',{staticClass:"mx-8 text-center pb-6"},[_c('h5',{staticClass:"mb-1 pt-12"},[_vm._v(_vm._s(_vm.title))]),_c('h6',[_vm._v(_vm._s(_vm.subtitle))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }